import { useState, useEffect } from 'react';
import KakaoTalkButton from '@/components/feature/KakaoTalkButton';

const navItems = [
  { label: '회사 소개', href: '/introduction' },
  { label: '가족간병 등록', href: '/register' },
  { label: '간병인 일자리', href: '/caregiver-job' },
  { label: '간병비 청구절차', href: '/process' },
  { label: '간병인 배정 후 필수사항', href: '/essential' },
  { label: '필요서류 안내', href: '/document' },
  { label: '고객 후기', href: '/review' },
  { label: '간병보험 상담', href: '/#insurance-consultation' },
  { label: '자주 묻는 질문', href: '/faq' },
];

const BRAND_COLOR = '#2E7D6B';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-black/20'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo / Brand */}
        <a href="/" className="flex items-center gap-3 flex-shrink-0 lg:mr-10">
          <img
            src="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/cba37159-d3f8-46db-9763-695cb2aae33c_unnamed.png?v=a72b44c5f622d80e8ffedcfaa4987858"
            alt="코리아케어러스 로고"
            className="h-10 w-auto object-contain"
          />
          <div className="leading-tight">
            <span
              className={`text-sm font-bold tracking-tight whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}
            >
              코리아케어러스
            </span>
            <span
              className={`block text-[10px] font-medium tracking-widest whitespace-nowrap ${scrolled ? 'text-gray-400' : 'text-white/70'}`}
            >
              KOREA CARERS
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#2E7D6B]' : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <div className="flex items-center gap-2 ml-2">
            <a
              href="/caregiver-job"
              className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all hover:opacity-90"
              style={{ backgroundColor: '#EA8C00', color: '#fff' }}
            >
              <i className="ri-briefcase-line mr-1"></i>
              간병인 일자리
            </a>
            <a
              href="tel:15668654"
              className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all"
              style={{ backgroundColor: BRAND_COLOR, color: '#fff' }}
            >
              <i className="ri-phone-line mr-1"></i>
              1566-8654
            </a>
            <KakaoTalkButton
              className="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all hover:opacity-90"
              style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
              ariaLabel="카톡 상담"
            >
              <i className="ri-kakao-talk-fill mr-1"></i>
              카톡 상담
            </KakaoTalkButton>
          </div>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="메뉴 열기"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="block px-6 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#2E7D6B] border-b border-gray-50 cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="tel:15668654"
            className="block px-6 py-3 text-sm font-semibold text-white cursor-pointer"
            style={{ backgroundColor: '#2E7D6B' }}
          >
            <i className="ri-phone-line mr-2"></i>1566-8654 전화 상담
          </a>
          <KakaoTalkButton
            className="block px-6 py-3 text-sm font-semibold cursor-pointer"
            style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
            ariaLabel="카톡 상담"
          >
            <i className="ri-kakao-talk-fill mr-2"></i>카톡 상담
          </KakaoTalkButton>
        </div>
      )}
    </header>
  );
}